export enum Typedata {
    'personal' = 'personal',
    'marital-status' = 'marital-status',
    'address' = 'address',
    'professional' = 'professional',
    'income' = 'income',
    'profile' = 'profile'
}
